"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _CategoryTopicListView = _interopRequireDefault(require("@insided/deprecated-preact-components/widget-category-and-topic-stream/CategoryTopicListView.sync"));

var _activityTopicListFooter = _interopRequireDefault(require("./activity-topic-list-footer"));

var _activityTopicListHeader = _interopRequireDefault(require("./activity-topic-list-header"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ActivityTopicsList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ActivityTopicsList, _Component);

  var _super = _createSuper(ActivityTopicsList);

  function ActivityTopicsList() {
    (0, _classCallCheck2.default)(this, ActivityTopicsList);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ActivityTopicsList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topics = _this$props.topics,
          totalTopicsCount = _this$props.totalTopicsCount,
          pagination = _this$props.pagination;

      if (!topics) {
        return null;
      }

      return (0, _preact.h)(_CategoryTopicListView.default, (0, _extends2.default)({
        headerSlot: (0, _preact.h)(_activityTopicListHeader.default, {
          totalTopicsCount: totalTopicsCount
        }),
        customPaginationSlot: (0, _preact.h)(_activityTopicListFooter.default, {
          pagination: pagination
        })
      }, this.props));
    }
  }]);
  return ActivityTopicsList;
}(_preact.Component);

exports.default = ActivityTopicsList;